import { render } from "./lycrud.vue?vue&type=template&id=ead58dac&scoped=true"
import script from "./lycrud.vue?vue&type=script&lang=js"
export * from "./lycrud.vue?vue&type=script&lang=js"

import "./lycrud.vue?vue&type=style&index=0&id=ead58dac&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead58dac"]])

export default __exports__